var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10239_105524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7625 0H61.225V60H18.75L18.7625 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.46289 0H18.7621V60H-2.46289V0ZM61.2246 0H82.4496V60H61.2371L61.2246 0ZM25.1246 29L23.4621 29.55L31.1371 36.3C31.7246 38.0125 30.9371 38.525 30.4371 39.425L38.7621 38.375L38.5621 46.75L40.2996 46.7125L39.9121 38.3875L48.2496 39.3875C47.7371 38.3 47.2746 37.725 47.7496 35.9875L55.4121 29.6125L54.0746 29.1125C52.9746 28.2625 54.5496 25.0375 54.7746 23C54.7746 23 50.3121 24.5375 50.0246 23.725L48.8746 21.5375L44.7996 26.0125C44.3621 26.125 44.1746 25.95 44.0621 25.575L45.9371 16.225L42.9621 17.9C42.7121 18.0125 42.4621 17.9125 42.3121 17.625L39.4371 11.875L36.4871 17.85C36.2621 18.0625 36.0371 18.0875 35.8621 17.9375L32.9996 16.35L34.7121 25.6125C34.5746 25.9875 34.2496 26.0875 33.8746 25.8875L29.9746 21.475C29.4746 22.2875 29.1246 23.6125 28.4496 23.9125C27.7746 24.2 25.5121 23.35 23.9996 23.0375C24.5246 24.8875 26.1246 27.9875 25.1246 29Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10239_105524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaIcon);
export default __webpack_public_path__ + "static/media/canadaIcon.4dee42352b18dff73d22316dbd090ce2.svg";
export { ForwardRef as ReactComponent };